function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  r: 17.9,
  cx: 18,
  cy: 18,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,1.1105289e-05 C8.0588745,1.1105289e-05 -5.68434189e-14,8.05889676 -5.68434189e-14,18.0000223 C-5.68434189e-14,27.9411478 8.0588745,36.0000223 18,36.0000223 C27.9411255,36.0000223 36.0000112,27.9411478 36.0000112,18.0000223 C36.005315,13.224498 34.1105987,8.64303884 30.7337911,5.2662312 C27.3569834,1.88942355 22.7755242,-0.00529274402 18,1.1105289e-05 Z M27.9,27.2260223 C27.562,27.6760223 27.226,28.1260223 26.888,28.5200223 L26.888,28.5200223 C21.6,34.5940223 12.77,32.7940223 7.426,28.5200223 C7.314,28.4640223 7.258,28.3520223 7.144,28.2940223 C7.144,28.2940223 7.2,22.6700223 7.144,22.6120223 C9.35769338,25.6809193 12.6562237,27.792465 16.37,28.5180223 L16.426,28.5180223 C17.1174318,28.6024572 17.8165682,28.6024572 18.508,28.5180223 L18.508,28.5180223 C18.62,28.5180223 18.732,28.4620223 18.908,28.4620223 C24.026,27.5620223 22.846,23.5680223 20.82,22.6620223 C19.076,21.9300223 15.982,21.7060223 12.326,20.1880223 C4.726,16.9880223 5.858,9.10602226 10.694,5.56202226 C13.788,3.31202226 19.92,2.18802226 27.344,7.08002226 L27.344,11.9820223 C27.344,11.9820223 22.612,7.36802226 17.212,7.14402226 C13.212,7.03202226 12.212,10.1820223 14.012,11.9260223 C17.05,14.8500223 20.088,13.3880223 25.6,16.4820223 C29.0936768,18.8873218 30.1028036,23.6012602 27.9,27.2260223 Z",
  fill: "#339A31"
}));

var SvgSBahn = function SvgSBahn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSBahn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/s-bahn.3e98b982.svg";
export { ForwardRef as ReactComponent };